import {useEffect, useRef} from 'react'

import styles from './ModalHandler.module.scss'

function ModalLoginHandler() {
  const submitBtnRef = useRef<HTMLButtonElement>(null)
  const closeBtn = useRef<HTMLButtonElement>(null)
  const closeBtnTimes = useRef<HTMLDivElement>(null)
  // Login Modal
  useEffect(() => {
    // Ensure the DOM elements exist
    const modalLogin = document.getElementById('loginPopup')

    // Helper function to toggle modal visibility
    const toggleModalVisibility = (modal: any, isVisible: any) => {
      if (modal) {
        modal.style.display = isVisible ? 'block' : 'none'
      }
    }
    // Login Modal
    const showLogin = (event: any) => {
      if (
        event.origin === origin &&
        typeof event.data === 'string' &&
        event.data.includes('RedirectLogin')
      ) {
        console.log('event.data', event.data)
        toggleModalVisibility(modalLogin, true)
      }
    }

    closeBtn.current?.addEventListener('click', () => {
      toggleModalVisibility(modalLogin, false)
    })

    closeBtnTimes.current?.addEventListener('click', () => {
      toggleModalVisibility(modalLogin, false)
    })

    if (submitBtnRef.current) {
      submitBtnRef.current.addEventListener('click', () => {
        const url = `${process.env.NEXT_PUBLIC_LOGIN_DOMAIN}/afreeca/login.php?szFrom=full&request_uri=${window.location.href}`
        window.location.href = url
      })
    }

    window.addEventListener('message', showLogin)

    return () => {
      window.removeEventListener('message', showLogin)
    }
  }, [])
  return (
    <div className={styles.loginPopup} id="loginPopup">
      <div className={styles['modal-content']}>
        <div className={styles['modal-header']}>
          <div className={styles['close-modal-login']} ref={closeBtnTimes}>
            &times;
          </div>
          <h4 className={styles['header-title']}>Thông báo</h4>
        </div>
        <div className={styles['modal-body']}>
          <p className={styles['title']}>Vui lòng đăng nhập để tiếp tục</p>
          <div style={{display: 'flex', justifyContent: 'center', gap: '10px'}}>
            <button type="button" ref={closeBtn} className={styles['cancel']}>
              Hủy bỏ
            </button>
            <button
              type="button"
              className={`${styles['btn-login']} ${styles['submit']}`}
              ref={submitBtnRef}
            >
              Xác nhận
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalLoginHandler
